import React, { useState } from "react";
import { Search, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheCinematicVision() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  const {
    ref: searchRef,
    isVisible: searchVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  const [searchQuery, setSearchQuery] = useState("");
  return <section data-section-id="21495" id="the-ultimate-desert-solitude" className="dark bg-background text-foreground relative h-screen w-full overflow-hidden !bg-[url(https://stirring-mammal.10web.cloud/wp-content/uploads/2026/04/the-one-camps-camel-ride.jpg)]">
      {}
      <div className="absolute inset-0 z-0">
        <video autoPlay muted loop playsInline poster="https://stirring-mammal.10web.cloud/wp-content/uploads/2026/04/the-one-camps-camel-ride.jpg" className="h-full w-full object-cover">
          <source src="/video/momentra_cinematic_loop.mp4" type="video/mp4" />
          {}
          <img src="https://stirring-mammal.10web.cloud/wp-content/uploads/2026/04/the-one-camps-camel-ride.jpg" alt="Luxury private desert camp at sunrise" className="h-full w-full object-cover" />
        </video>
        {}
        <div className="absolute inset-0 bg-black/30" />
      </div>

      {}
      <div className="relative z-10 flex h-full flex-col items-center justify-center px-4 text-center">
        
        {}
        <div ref={textRef} className={`max-w-5xl transition-all duration-1000 ease-out ${textVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <h1 className="font-default font-medium leading-tight text-foreground drop-shadow-lg !text-[55px]">Luxury Desert Camp Oman | Private Retreat in Wahiba Sands</h1>
        </div>

        {}
        <div ref={searchRef} className={`mt-12 w-full max-w-lg transition-all delay-300 duration-1000 ease-out ${searchVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          
        </div>

        {}
        <div className={`mt-10 transition-all delay-500 duration-1000 ease-out ${searchVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <Link to="#">
            <Button size="lg" className="relative h-14 overflow-hidden rounded-md border border-primary/30 bg-primary/80 px-10 font-default text-lg font-medium text-primary-foreground shadow-xl transition-all duration-500 hover:scale-105 hover:bg-primary hover:shadow-2xl">
              <span className="relative z-10">Book Your Camp</span>
              {}
              <div className="absolute inset-0 -z-0 bg-gradient-to-r from-transparent via-foreground/10 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
            </Button>
          </Link>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce text-foreground/50">
        <div className="h-10 w-6 rounded-full border-2 border-foreground/30 p-1">
          <div className="h-2 w-full rounded-full bg-foreground/50" />
        </div>
      </div>
    </section>;
}